// extracted by mini-css-extract-plugin
export default {"dot":"Timeline_dot__MnQqv","timeline":"Timeline_timeline__730+d"};